import Vue from "vue";
import Component from "./Index.vue";

const selectRoomInfo = Vue.extend(Component);
const selectRoomInfoModal = options => {
  if (Vue.prototype.$isServer) return;

  const {
    //autoClose,
    ...rest
  } = options;
  const instance = new selectRoomInfo({
    propsData: {
      ...rest,
    },
    data: {},
  });
  instance.vm = instance.$mount();
  document.body.appendChild(instance.vm.$el);
  instance.vm.visible = true;

  instance.vm.$on("submit", param => {
    if (instance.submit) {
      instance.submit(param);
    }
  });
  instance.vm.$on("destroy", () => {
    document.body.removeChild(instance.vm.$el);
  });
  return instance.vm;
};

export default selectRoomInfoModal;
